
import Mobile_index from "./mobile/index";
import Pc_index from "./pc/index";
import Menu from "./mobile/menu.vue";
// import Menu from "../../../../public/menu.vue";

export default {
    install(Vue, options) {
        Vue.component('Mobile_index', Mobile_index);
        Vue.component('Pc_index', Pc_index);
        Vue.component('Menu', Menu);
      
       
　　}
}     